/**
 * List - H5 版本，使用 zarm List
 */
import React from 'react';
import { List as ZarmList } from 'zarm-v3';

export interface ListProps {
  children?: React.ReactNode;
}

export interface ListItemProps {
  title?: string;
  hasArrow?: boolean;
  className?: string;
  onClick?: () => void;
  children?: React.ReactNode;
}

export const List: React.FC<ListProps> & { Item: React.FC<ListItemProps> } = ({ children }) => (
  <ZarmList>{children}</ZarmList>
);

List.Item = ({ title, hasArrow = true, className, onClick, children }: ListItemProps) => (
  <ZarmList.Item title={title} hasArrow={hasArrow} className={className} onClick={onClick}>
    {children}
  </ZarmList.Item>
);

export default List;
